import Pools from './Pools';
import useLiquidityPools from '@/application/read/pools/useLiquidityPools';

export interface PoolsContainerProps {}

const PoolsContainer = ({}: PoolsContainerProps) => {
  const { data: pools, status } = useLiquidityPools({ exists: true });

  return <Pools status={status} pools={pools} />;
};

export default PoolsContainer;
